import { Button } from '@/components/ui/Button';
import { cn } from '@/utils/cn';

type RecommendationBulkBarProps = {
  selectedCount: number;
  onApplySelected: () => void;
  onDismissSelected: () => void;
  onClearSelection: () => void;
  applying?: boolean;
  applyDisabled?: boolean;
  applyDisabledReason?: string;
  className?: string;
};

export function RecommendationBulkBar({
  selectedCount,
  onApplySelected,
  onDismissSelected,
  onClearSelection,
  applying = false,
  applyDisabled = false,
  applyDisabledReason = 'Apply is available for Sponsored Products keywords only.',
  className,
}: RecommendationBulkBarProps) {
  if (selectedCount <= 0) return null;

  return (
    <div
      className={cn(
        'sticky top-0 z-20 flex flex-wrap items-center gap-2 rounded-xl border border-brand/20 bg-brand/5 px-3 py-2',
        className
      )}
    >
      <span className="text-sm font-medium text-foreground">{selectedCount} selected</span>
      <div className="ml-auto flex flex-wrap items-center gap-2">
        <Button
          type="button"
          size="sm"
          onClick={onApplySelected}
          disabled={applying || applyDisabled}
          title={applyDisabled ? applyDisabledReason : undefined}
        >
          {applying ? 'Applying…' : `Apply selected (${selectedCount})`}
        </Button>
        <Button type="button" variant="secondary" size="sm" onClick={onDismissSelected} disabled={applying}>
          Dismiss selected
        </Button>
        <Button type="button" variant="ghost" size="sm" onClick={onClearSelection} disabled={applying}>
          Clear
        </Button>
      </div>
    </div>
  );
}
